import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const CrudText = (props) => {
    const { children } = props;
    return <div className="crud-text-description">{children}</div>;
};

CrudText.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default CrudText;
